import request from '@/utils/request'

// ---------------会员管理---------------
// ---------------会员管理列表---------------
export function fetchList(query) { // 查询门店会员列表
  return request({
    url: '/hotelMember/hotel/hotelMember/queryHotelMember',
    method: 'get',
    params: query
  })
}

export function getLevels(query) { // 获取门店等级列表
  return request({
    url: '/hotelMember/hotel/hotelLevel/getLevels',
    method: 'get',
    params: query
  })
}

// 单店储值列表统计
export function queryReportDataTotal(params) {
  return request({
    url: '/hotelMember/hotel/promotion/queryReportDataTotal',
    method: 'get',
    params: params
  })
}


export function getIdType(query) { // 数据字典获取证件类型
  return request({
    url: '/hotelMember/hotel/common/getIdType',
    method: 'get',
    params: query
  })
}

export function getDeductionByCate(query) { // 储值扣减--交易类型
  return request({
    url: '/hotelMember/hotel/promotion/getDeductionByCate',
    method: 'get',
    data: query
  })
}
// ---------------会员导入---------------
export function importMember(file) { // 导入会员
  return request({
    url: '/hotelMember/hotel/hotelMember/importMember',
    method: 'post',
    data: { file }
  })
}

export function downLoadErrorMemberInfo(errorFlag) { // 下载异常用户汇总信息
  return request({
    url: '/hotelMember/hotel/hotelMember/downLoadErrorMemberInfo',
    method: 'get',
    responseType: 'blob',
    params: { errorFlag }
  })
}

export function downMember(pv) { // 下载会员导入模板
  return request({
    url: '/hotelMember/hotel/hotelMember/downMemberTemplate',
    method: 'get',
    responseType: 'blob',
    params: { pv }
  })
}
// ---------------会员导出---------------
export function exportMember(params) { // 会员导出
  return request({
    url: '/hotelMember/hotel/hotelMember/exportMember',
    method: 'get',
    responseType: 'blob',
    params: params
  })
}
// ---------------会员新增，修改---------------
export function fetchMember(data) { // 单店会员新增/修改
  return request({
    url: '/hotelMember/hotel/hotelMember/addOrUpdateMember',
    method: 'post',
    data
  })
}
// ---------------查看会员，修改会员查询会员信息---------------
export function levelMember(hotelMemberNo) { // 获取会员信息编辑回显
  return request({
    url: '/hotelMember/hotel/hotelMember/getMemberByHotelMemberNo',
    method: 'get',
    params: { hotelMemberNo }
  })
}

// -------充值-----------
export function fetchActivityLevelList(query) { // 获取档位
  return request({
    url: '/hotelMember/hotel/promotion/getPromotionAndLevel',
    method: 'get',
    params: query
  })
}

export function getPaymentType(query) { // 获取支付方式
  return request({
    url: '/hotelMember/hotel/common/getPaymentType',
    method: 'get',
    params: query
  })
}

export function createCredit(data) { // 充值
  return request({
    url: '/hotelMember/hotel/promotion/credit',
    method: 'post',
    data
  })
}
// ---------------储值扣减---------------

export function getConsumption(data) { // 储值扣减
  return request({
    url: '/hotelMember/hotel/promotion/consumption',
    method: 'post',
    data
  })
}

// ---------------积分变更---------------

export function updatePoint(data) { // 积分变更
  return request({
    url: '/hotelMember/hotel/memberPoint/change',
    method: 'post',
    data
  })
}

// ---------------积分查询---------------

export function fetchStatistics(hotelMemberNo) { // 获取储值总额
  return request({
    url: '/hotelMember/hotel/promotion/getFlowStatistics',
    method: 'get',
    params: { hotelMemberNo }
  })
}

export function getIntegralList(query) { // 积分流水查询
  return request({
    url: '/hotelMember/hotel/memberPoint/flowList',
    method: 'get',
    params: query
  })
}

// ---------------储值查询---------------

export function fetchCreditList(query) { // 活动储值查询
  return request({
    url: '/hotelMember/hotel/promotion/getTransactionFlowList',
    method: 'get',
    params: query
  })
}

export function getTransactionFlowListWithoutPage(query) { // 活动储值查询打印
  return request({
    url: '/hotelMember/hotel/promotion/getTransactionFlowListWithoutPage',
    method: 'get',
    params: query
  })
}

export function selectAllDeduction(data) { // 储值查询下拉框
  return request({
    url: '/hotelMember/hotel/promotion/selectAllDeduction',
    method: 'get',
    data
  })
}

// ---------------活动管理---------------
// --------获取列表--------
export function getActivityList(query) { // 获取列表
  return request({
    url: '/hotelMember/hotel/promotion/list',
    method: 'get',
    params: query
  })
}
// --------添加活动,编辑活动--------
export function createActivity(data) { // 添加活动
  return request({
    url: '/hotelMember/hotel/promotion/save',
    method: 'post',
    data
  })
}
// --------编辑活动--------
export function backActivity(hotelPromotionId) { // 获取活动详情
  return request({
    url: '/hotelMember/hotel/promotion/get',
    method: 'get',
    params: { hotelPromotionId }
  })
}
// --------编辑档位--------
export function fetchLevelList(hotelPromotionId) { // 获取列表
  return request({
    url: '/hotelMember/hotel/promotionLevel/list',
    method: 'get',
    params: { hotelPromotionId }
  })
}
// --------编辑档位-添加档位--------
export function createLevel(data) { // 添加档位
  return request({
    url: '/hotelMember/hotel/promotionLevel/add',
    method: 'post',
    data
  })
}
// --------编辑档位-删除档位--------
export function deleteLevel(hotelPromotionLevelId) { // 删除档位
  return request({
    url: '/hotelMember/hotel/promotionLevel/delete',
    method: 'get',
    params: { hotelPromotionLevelId }
  })
}
// --------删除活动--------
export function deleteActivity(hotelPromotionId) { // 删除活动
  return request({
    url: '/hotelMember/hotel/promotion/delete',
    method: 'get',
    params: { hotelPromotionId }
  })
}
// ------------积分管理---------------
export function queryHotelIntegralProportion(params) { // 查询
  return request({
    url: '/hotelMember/hotel/memberPoint/queryHotelIntegralProportion',
    method: 'get',
    params: params
  })
}
export function setIntegralProportion(data) { // 保存
  return request({
    url: '/hotelMember/hotel/memberPoint/setIntegralProportion',
    method: 'post',
    data
  })
}
// 打印
export function getTransactionFlowBill(params) { // 查询
  return request({
    url: '/hotelMember/hotel/promotion/getTransactionFlowBill',
    method: 'get',
    params: params
  })
}
// 会员数据列表
export function getQueryMemberBySource(params) {
  return request({
    url: '/admin/member/queryMemberBySource',
    method: 'get',
    params: params
  })
}
// 会员数据列表统计
export function getCountByHotelCode(params) {
  return request({
    url: '/admin/member/getCountByHotelCode',
    method: 'get',
    params: params
  })
}
// 单店储值列表
export function getQueryReportDateList(params) {
  return request({
    url: '/hotelMember/hotel/promotion/queryReportDataList',
    method: 'get',
    params: params
  })
}
// 单点会员储值消费报表导出
export function exportTransactionReport(params) {
  return request({
    url: '/hotelMember/hotel/promotion/exportTransactionReport',
    method: 'get',
    responseType: 'blob',
    params: params
  })
}
// 获取证件类型的接口
export function getQzCredentialsType(params) {
  return request({
    url: '/dataDict/qzCredentialsType/findAll',
    method: 'get',
    params: params
  })
}

// 轻住会员管理页面查询列表
export function getQzMember(data) {
  return request({
    url: '/member/queryMemberListForPmsQZMemberManager',
    method: 'post',
    data
  })
}
// 会员转化身份识别
export function getIdMembers(params) {
  return request({
    url: '/member/queryMemberInfoByPhones',
    method: 'get',
    params
  })
}
// 会员转化身份识别 文案
export function getMemberRightsInfo(params) {
  return request({
    url: '/system/settings/fe/getMemberRightsInfo',
    method: 'get',
    params
  })
}

// 客户档案列表
export function hotelGuestList(query) { // 查询门店会员列表
  return request({
    url: '/hotelMember/hotel/hotelGuest/list',
    method: 'get',
    params: query
  })
}

// 客户档案详情	
export function hotelGuestDetail(query) { // 查询门店会员列表
  return request({
    url: '/hotelMember/hotel/hotelGuest/detail',
    method: 'get',
    params: query
  })
}

// 入住历史列表	
export function hotelGuestCheckinList(query) { // 查询门店会员列表
  return request({
    url: '/hotelMember/hotel/hotelGuest/checkinList',
    method: 'get',
    params: query
  })
}

// 客户档案维护	
export function hotelGuestEdit(data) { // 查询门店会员列表
  return request({
    url: '/hotelMember/hotel/hotelGuest/edit',
    method: 'post',
    data
  })
}

// 查询客户档案ID及酒店维度标签
export function hotelGuestLabelDetail(params) {
  return request({
    url: '/hotelMember/hotel/hotelGuest/label/detail',
    method: 'get',
    params
  })
}

// 新增客户标签
export function hotelGuestLabelAdd(data) {
  return request({
    url: '/hotelMember/hotel/hotelGuest/label/add',
    method: 'post',
    data
  })
}

// 删除客户标签
export function hotelGuestLabelDelete(data) {
  return request({
    url: '/hotelMember/hotel/hotelGuest/label/delete',
    method: 'post',
    data
  })
}

// 白名单列表
export function whitePersonList(query) {
  return request({
    url: '/hardware/monitor/whitePersonList',
    method: 'get',
    params: query
  })
}

// 新增白名单		
export function addWhitePerson(data) {
  return request({
    url: '/hardware/monitor/addWhitePerson',
    method: 'post',
    data
  })
}


// 删除白名单			
export function delWhitePerson(query) {
  return request({
    url: '/hardware/monitor/delWhitePerson',
    method: 'get',
    params: query
  })
}

// 报警列表				
export function alarmList(query) {
  return request({
    url: '/hardware/monitor/alarmList',
    method: 'get',
    params: query
  })
}

// 报警忽略					
export function ignoreAlarm(query) {
  return request({
    url: '/hardware/monitor/ignoreAlarm',
    method: 'get',
    params: query
  })
}

// 报警加白						
export function alarmAddWhite(query) {
  return request({
    url: '/hardware/monitor/alarmAddWhite',
    method: 'get',
    params: query
  })
}

// 在住列表							
export function canAddWhitePerson(query) {
  return request({
    url: '/hardware/monitor/canAddWhitePerson',
    method: 'get',
    params: query
  })
}
